module.exports = __webpack_public_path__ + "static/img/cj03.6254dd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/cj03.png
// module id = 147
// module chunks = 0